(() => {
  if (window.pampasCartCountReady) return;
  window.pampasCartCountReady = true;

  let requestPending = false;

  const visibleCount = (cart) => {
    if (!Array.isArray(cart?.items)) return Number(cart?.item_count) || 0;

    return cart.items.reduce((total, item) => {
      const isLinkedAddon = Boolean(item?.properties?._linked_to);
      return isLinkedAddon ? total : total + (Number(item.quantity) || 0);
    }, 0);
  };

  const render = (count) => {
    document.querySelectorAll('[data-pampas-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.classList.toggle('cart-link__bubble--visible', count > 0);

      const cartLink = badge.closest('.js-drawer-open-cart');
      if (cartLink) {
        const label = cartLink.querySelector('.icon__fallback-text')?.textContent?.trim() || 'Cart';
        cartLink.setAttribute('aria-label', `${label}: ${count}`);
      }
    });
  };

  const refresh = () => {
    if (requestPending) return;
    requestPending = true;

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cart) => render(visibleCount(cart)))
      .finally(() => {
        requestPending = false;
      });
  };

  [
    'cart:build',
    'cart:updated',
    'cart:change',
    'cart:quantity',
    'ajaxProduct:added',
    'product:added',
  ].forEach((eventName) => document.addEventListener(eventName, refresh));

  const drawerProducts = document.querySelector('#CartDrawer [data-products]');
  if (drawerProducts) {
    new MutationObserver(refresh).observe(drawerProducts, {
      childList: true,
      subtree: true,
    });
  }

  refresh();
})();
